import { type ReactElement } from 'react'
import PrimarySignatureLogo from '../../../../shared/components/ui/logos/PrimarySignatureLogo'
import { FooterDisclaimer } from './components/FooterDisclaimer'
import { SignInForm } from './components/SignInForm'

export default function RightPanel (): ReactElement {
  return (
    <div className="w-full md:w-1/2 h-screen flex justify-center items-center">
      <div className="w-1/2">
        <div className="flex justify-center">
          <div className="w-2/3 my-10 block md:hidden">
            <PrimarySignatureLogo />
          </div>
        </div>
        <h2 className="text-2xl text-wpy-logo-blue-700 font-bold text-center">
          Sign in to Power Your
        </h2>
        <h2 className="text-2xl text-wpy-logo-blue-700 font-bold text-center mb-8">
          Payment Processing
        </h2>
        <SignInForm />
        <FooterDisclaimer />
      </div>
    </div>
  )
}
